import { render, staticRenderFns } from "./DsfPptSetting.vue?vue&type=template&id=66ad761a&"
import script from "./DsfPptSetting.vue?vue&type=script&lang=js&"
export * from "./DsfPptSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ad761a')) {
      api.createRecord('66ad761a', component.options)
    } else {
      api.reload('66ad761a', component.options)
    }
    module.hot.accept("./DsfPptSetting.vue?vue&type=template&id=66ad761a&", function () {
      api.rerender('66ad761a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/control/DsfPptSetting.vue"
export default component.exports